<template>

    <nav class="navbar navbar-expand-md navbar-dark fixed-top bg-dark">
        <a class="navbar-brand" href="#">SportService</a>
        <button class="navbar-toggler collapsed" type="button" data-toggle="collapse" data-target=".dual-collapse2"
                aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="navbar-collapse collapse w-100 order-0 dual-collapse2">
            <ul class="navbar-nav ml-auto">

                <template>
                    <router-link :to="{ name: 'welcome' }" tag="li" class="nav-item">
                        <a class="nav-link">
                            {{ $t('home') }}
                        </a>
                    </router-link>
                </template>

                <template>
                    <router-link :to="{ name: 'pricing' }" tag="li" class="nav-item">
                        <a class="nav-link">
                            {{ $t('pricing') }}
                        </a>
                    </router-link>
                </template>

                <template>
                    <router-link :to="{ name: 'about' }" tag="li" class="nav-item">
                        <a class="nav-link">
                            {{ $t('about_us') }}
                        </a>
                    </router-link>
                </template>

                <!--<template>-->
                <!--<router-link :to="{ name: 'welcome' }" tag="li" class="nav-item">-->
                <!--<a class="nav-link">-->
                <!--{{ $t('contacts') }}-->
                <!--</a>-->
                <!--</router-link>-->
                <!--</template>-->

                <!-- Authenticated -->
                <template v-if="authenticated">
                    <!--<router-link :to="{ name: 'catalog.index' }" tag="li" class="nav-item">-->
                        <!--<a class="nav-link">-->
                            <!--{{ $t('catalog') }}-->
                        <!--</a>-->
                    <!--</router-link>-->
                    <router-link :to="{ name: 'user.profile' }" tag="li" class="nav-item username-link">
                        <a class="nav-link">
                            <i class="fa fa-user-circle-o" aria-hidden="true"></i> {{ user.name }}
                        </a>
                    </router-link>
                    <li class="nav-item">
                        <a @click.prevent="logout" href="#" class="nav-link logout-link">
                            <i class="fa fa-sign-out" aria-hidden="true"></i> {{ $t('logout') }}
                        </a>
                    </li>
                </template>

                <!-- Guest -->
                <template v-else>
                    <router-link :to="{ name: 'register' }" tag="li" class="nav-item" active-class="active">
                        <a class="nav-link nav-link__start-using">
                            {{ $t('start_using') }}
                        </a>
                    </router-link>


                    <router-link :to="{ name: 'login' }" tag="li" class="nav-item" active-class="active">
                        <a class="nav-link">
                            {{ $t('menu_login') }}
                        </a>
                    </router-link>
                </template>
            </ul>
        </div>
    </nav>


    <!--<nav class="navbar navbar-expand-lg navbar-light bg-light">-->
    <!--<div class="container">-->
    <!--<router-link :to="{ name: 'welcome' }" class="navbar-brand">-->
    <!--{{ appName }}-->
    <!--</router-link>-->

    <!--<button class="navbar-toggler" type="button" data-toggle="collapse"-->
    <!--data-target="#navbarToggler" aria-controls="navbarToggler"-->
    <!--aria-expanded="false" :aria-label="$t('toggle_navigation')"-->
    <!--&gt;-->
    <!--<span class="navbar-toggler-icon"></span>-->
    <!--</button>-->

    <!--<div class="collapse navbar-collapse" id="navbarToggler">-->
    <!--<ul class="navbar-nav mr-auto mt-2 mt-lg-0">-->
    <!--&lt;!&ndash; <li class="nav-item">-->
    <!--<a class="nav-link" href="#">Link</a>-->
    <!--</li> &ndash;&gt;-->
    <!--</ul>-->


</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        data: () => ({
            appName: window.config.appName
        }),

        computed: mapGetters({
            user: 'authUser',
            authenticated: 'authCheck'
        }),

        methods: {
            async logout () {
                // Log out the user.
                await this.$store.dispatch('logout');

                // Redirect to login.
                this.$router.push({ name: 'login' });
            }
        }
    }
</script>

<style scoped>
    .navbar {
        border: 1px solid #d3e0e9;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Navbar.vue